<template>
  <div v-if="dapps && dapps.length>0" class="dapp-row-list row">
    <div class="dapp-row-list-header">
      <div class="dapp-row-header-index">{{ $t('column.index') }}</div>
      <div class="dapp-row-header-name">{{ $t('column.name') }}</div>
      <div class="dapp-row-header-category">{{ $t('column.category') }}</div>

      <a v-for="key in ['user1d', 'tx1d', 'value1d', 'user7d', 'tx7d', 'value7d']" :key="key"
         class="dapp-row-header-statistics" :class="{selected: key === sort}"
         @click="onClickHandler && onClickHandler(key)">
        {{ $t('column.'+key) }}
      </a>
    </div>
    <div v-for="dapp in dapps" :key="dapp.key" class="dapp-row-list-item">
      <DAppRow class="dapp-item" :dapp="dapp"></DAppRow>
    </div>
  </div>
</template>

<script>
  import DAppRow from './DAppRow'

  export default {
    name: 'DAppRowList',
    components: {DAppRow},
    props: ['dapps', 'sort', 'onClickHandler']
  }
</script>

<style lang="scss" scoped>

  @import "../utils";

  .dapp-row-list {
    margin: 10px 0 30px 0;
    background-color: #E4E4E4;
    padding: 20px;
  }

  .dapp-row-list-header {
    @include flex-horizontal;
    width: 100%;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    > * {
      flex-grow: 1;
      width: 0;
      text-align: center;
      padding: 0 15px;
    }
  }

  .dapp-row-header-index {
    flex-grow: 0.3;
  }

  .dapp-row-header-name {
    flex-grow: 2;
    text-align: left;
  }

  .dapp-row-header-statistics {
    text-align: right;

    &.selected {
      font-weight: bold;
      &:after {
        content: '▼'
      }
    }
  }

  .dapp-row-list-item {
    width: 100%;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppRowList.vue